import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import { printDamageReport } from './printDamageReport';

export default {
    name: 'DamageReports',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewDamageReportsUi()) {
            this.logout();
            return;
        }
        this.GetInfo();
        if (this.isFacilityUser) {
            this.loadEligibleBatches();
        }
    },

    computed: {
        isMinistryAdmin() {
            return this.isMinistryStockAdminUi();
        },
        isFacilityUser() {
            return this.canCreateDamageReportsUi();
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            statusFilter: 0,
            Info: [],
            detail: null,
            detailDialog: false,
            createDialog: false,
            batchSearch: '',
            eligibleBatches: [],
            createForm: {
                productsId: null,
                productsCountId: null,
                quantity: 1,
                reason: 1,
                note: '',
                imagePaths: ''
            },
            reviewDialog: false,
            reviewForm: {
                id: 0,
                approve: true,
                reviewNote: ''
            }
        };
    },

    methods: {
        statusLabel(s) {
            if (s === 1) return 'مرسل';
            if (s === 2) return 'معتمد';
            if (s === 3) return 'مرفوض';
            return '-';
        },
        reasonLabel(r) {
            if (r === 1) return 'انتهاء صلاحية';
            if (r === 2) return 'سوء تخزين';
            if (r === 3) return 'سوء نقل';
            return 'أخرى';
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetDamageReports(this.pageNo, this.pageSize, this.Search, this.statusFilter)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },
        loadEligibleBatches() {
            this.$http.GetEligibleDamageBatches(this.batchSearch)
                .then((response) => {
                    this.eligibleBatches = response.data.info || [];
                })
                .catch(() => {
                    this.eligibleBatches = [];
                });
        },
        openCreateDialog() {
            this.createForm = {
                productsId: null,
                productsCountId: null,
                quantity: 1,
                reason: 1,
                note: '',
                imagePaths: ''
            };
            this.batchSearch = '';
            this.loadEligibleBatches();
            this.createDialog = true;
        },
        onBatchChange() {
            const batch = this.eligibleBatches.find((item) => item.id === this.createForm.productsCountId);
            if (!batch) return;
            this.createForm.productsId = batch.productsId;
            this.createForm.quantity = batch.quantity > 0 ? 1 : 0;
        },
        submitCreate() {
            if (!this.createForm.productsId || !this.createForm.productsCountId || Number(this.createForm.quantity) <= 0) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر دفعة وحدد كمية صالحة.');
                return;
            }
            const body = {
                productsId: this.createForm.productsId,
                productsCountId: this.createForm.productsCountId,
                quantity: Number(this.createForm.quantity),
                reason: Number(this.createForm.reason),
                note: this.createForm.note || null,
                imagePaths: this.createForm.imagePaths || null
            };
            this.$blockUI.Start();
            this.$http.CreateDamageReport(body)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data.message || 'تم إرسال بلاغ التالف.');
                    this.createDialog = false;
                    this.GetInfo(1);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        openDetail(item) {
            this.$blockUI.Start();
            this.$http.GetDamageReport(item.id)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.detail = response.data.info;
                    this.detailDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },
        openReview(approve) {
            this.reviewForm = {
                id: this.detail.id,
                approve,
                reviewNote: ''
            };
            this.reviewDialog = true;
        },
        submitReview() {
            this.$blockUI.Start();
            this.$http.ReviewDamageReport(this.reviewForm)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data);
                    this.reviewDialog = false;
                    this.detailDialog = false;
                    this.detail = null;
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        printDetail() {
            if (!this.detail || !this.detail.canPrint) return;
            this.$http.MarkDamageReportPrinted(this.detail.id)
                .then(() => {
                    const opened = printDamageReport(this.detail);
                    if (!opened) {
                        this.$helper.ShowMessage('warning', 'تنبيه', 'تعذر فتح نافذة الطباعة.');
                        return;
                    }
                    this.openDetail({ id: this.detail.id });
                })
                .catch((err) => {
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تسجيل الطباعة.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        }
    }
};
